import classNames from 'classnames';
import { ChangeEventHandler, FC, FocusEventHandler, ReactNode } from 'react';

import { PropsWithClassname } from '@/app/types';

export interface TextareaProps extends PropsWithClassname {
  name: string;
  value: string | number;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
  label?: string;
  disabled?: boolean;
  isErrorVisible?: boolean;
  errorMessage?: ReactNode;
  note?: string;
  placeholder?: string;
  rows?: number;
}

const Textarea: FC<TextareaProps> = ({
  name,
  onChange,
  onBlur,
  label,
  disabled,
  isErrorVisible,
  errorMessage,
  note,
  value,
  placeholder,
  rows,
  className,
}) => {
  return (
    <div className={classNames(className, '')}>
      {!!label && <label className="block mb-[8px] font-medium text-[16px] leading-[24px]">{label}</label>}
      {!!errorMessage && isErrorVisible && <div className="text-warning font-medium mb-[8px]">{errorMessage}</div>}
      <div className="relative">
        <textarea
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          value={value}
          placeholder={placeholder}
          rows={rows}
          className={classNames(
            className,
            'w-full border border-neutral-light focus:border-neutral-dark rounded text-neutral-dark px-[24px] py-[12px] outline-0',
            {
              'text-neutral-mid': disabled && !isErrorVisible,
              'border-warning focus:border-warning has-error': isErrorVisible,
              'mb-[8px]': !!note,
              'mb-[32px]': !note,
            },
          )}
        />
      </div>
      {!!note && <small className="block text-[12px] leading-[1.4] text-neutral-mid mb-[32px]">{note}</small>}
    </div>
  );
};

export default Textarea;
